<template>
    <div class="m-cnt">
        <div class="vip-page">
            <div class="vip-container">
                <div class="login-mod">
                    <mt-field placeholder="请输入手机号" type="tel" v-model="mobile" :attr="{ maxlength: 11 }"></mt-field>
                     <div class="code-input">
                        <mt-field placeholder="请输入验证码" type="code" v-model="code" :attr="{ maxlength: 6 }">
                        </mt-field>
                        <div class="code-btn" :class="codeDisabled ? 'disabled' : ''" @click="getCode">
                            {{ codeDisabled ? `${count}s` : "获取" }}
                        </div>
                    </div>
                    <div class="login-btn" @click="getVip">点击领取福利</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import User from "@/api/user.js";
    import Mkt from "@/api/mkt.js";
    import Util from "@/utils/util.js";
    import Device from "@/utils/device.js";
    import { Toast, Indicator } from 'mint-ui';
    import Cookies from 'js-cookie';
    export default {
        data() {
            return {
                activityId: this.$route.params.activityId,
                isAPP: false,
                isMINI: false,
                mobile: '',
                code: '',
                codeDisabled: false,
                count: 60
            }
        },
        mounted() {
            // if (Device.isAPP()) {
            //     this.isAPP = true
            //     // Util.setLogin("app")
            // } else if (Util.getQueryVariable("terminal") == "MiniProgram") {
            //     this.isMINI = true
            //     // Util.setLogin("MiniProgram")
            // } else {
            //     this.isAPP = false
            // }
        },
        methods: {
            mobileValidate(val) {
                if ((/^1[0-9]\d{9}$/.test(val))) {
                    return true
                } else {
                    return false
                }
            },
            countDown() {
                if (!this.codeDisabled) {
                    return
                }
                setTimeout(function () {
                    this.count -= 1
                    this.codeDisabled = true
                    if (this.count == 0) {
                        this.count = 60
                        this.codeDisabled = false
                    }
                    this.countDown()
                }.bind(this), 1000)
            },
            getCode() {
                if (this.codeDisabled) {
                    return
                }
                if (!this.mobileValidate(this.mobile)) {
                    Toast({
                        message: "请输入正确的手机号",
                        position: "middle",
                        duration: 2000,
                    });
                    return;
                }
                this.codeDisabled = true;
                User.isRegister(this.mobile).then((res) => {
                    this.isRegister = res.results.isRegister;
                    User.getCode(this.mobile, {
                        token: res.results.token,
                        randomStr: res.results.randomStr
                    }).then((res) => {
                        if (res.code == 200) {
                            Toast({
                                message: "验证码已发送",
                                position: "middle",
                                duration: 3000,
                            });
                            // 倒计时
                            this.countDown();
                        } else {
                            this.codeDisabled = false;
                            Toast({
                                message: res.message,
                                position: "middle",
                                duration: 3000,
                            });
                        }
                    }).catch((err) => {
                        this.codeDisabled = false;
                    });
                });
            },
            getVip() {
                if (!this.mobileValidate(this.mobile)) {
                    Toast({
                        message: '手机号输入错误',
                        position: 'middle',
                        duration: 3000
                    })
                    return
                }
                if (this.code == '') {
                    Toast({
                        message: "请输入验证码",
                        position: "middle",
                        duration: 3000,
                    });
                    return
                }
                // if (!Cookies.get("token")) {
                //     if (this.isAPP) {
                //         // Toast("请先登录~")
                //     } else if (this.isMINI) {
                //         let redirect_uri = encodeURIComponent(`/pages/webview/webview?url=${window.location.href}`)
                //         wx.miniProgram.navigateTo({
                //             url: `/pages/user/login/login?redirect_uri=${redirect_uri}`
                //         })
                //         return
                //     } else {
                //         this.$loginModal()
                //         return
                //     }
                // }
                Indicator.open("领取中")
                let obj = {
                    activityId: this.activityId,
                    mobile: this.mobile,
                    validCode: this.code
                }
                Mkt.getVip(obj).then(res => {
                    if (res.code == 200) {
                        Indicator.close()
                        Toast('领取成功！')
                    } else {
                        Indicator.close()
                        Toast(res.message)
                    }
                }).catch(err => {
                    Indicator.close()
                    Toast(err)
                })
            }
        }
    }
</script>
<style lang="less">
    .vip-page {
        width: 100%;
        height: 1357px;
        background-image: url(http://img.huashitong.net/mkt/wjdc-bg.png);
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;

        .vip-container {
            position: absolute;
            top: 935px;
            left: 135px;
        }

        .login-mod {
            width: 480px;
        }

        .mint-cell {
            background-color: transparent;
        }

        .mint-cell-wrapper {
            height: 88px;
            border: 2px solid #FFAED6;
            background: #FBF5FF;
            border-radius: 44px !important;
            margin-bottom: 20px;
            position: relative;
        }

        .mint-field-core {
            text-align: center;
            padding: 0 20px;
            background-color: #FBF5FF;
            color: #999;
            font-size: 28px;
        }

        .code-input {
            display: flex;
            justify-content: space-between;

            .mint-field {
                width: 320px;
            }
        }

        .code-btn {
            width: 150px;
            height: 88px;
            line-height: 88px;
            border: 2px solid #FFAED6;
            background: #FBF5FF;
            border-radius: 44px;
            text-align: center;
            color: #333;
            font-size: 32px;
            cursor: pointer;
        }

        .login-btn {
            margin-top: 0;
            cursor: pointer;
            height: 88px;
            border-radius: 44px;
            color: #000;
            font-size: 36px;
            background: linear-gradient(-45deg, #AAC0FF, #FFD7F6);
            box-shadow: 0px 9px 18px 0px rgba(96, 112, 234, 0.25);
        }
    }
</style>